{
  "coordinator_actions": "<ul><li>Controleer of de invoer in Abacus goed is overgenomen van het papieren proces-verbaal.</li><li>Zit de fout ook in het papieren proces-verbaal? Los de fout dan daar op.</li></ul>",
  "errors": "foutmeldingen",
  "multiple_action_title": "Voor alle {type} geldt het volgende:",
  "typist_actions": "<ul><li>Heb je iets niet goed overgenomen? Herstel de fout en ga verder.</li><li>Heb je alles gecontroleerd en komt je invoer overeen met het papier? Ga dan verder.</li></ul>",
  "typist_title": "Controleer je antwoorden",
  "warnings": "waarschuwingen"
}
